var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIsoFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 218 211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#273b3f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logitipo"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "151.69 95.63 145.43 83.83 139.73 100.42 144.29 110.17 108.5 179.67 72.53 109.81 115.55 28.86 112.13 7 6.69 206 23.66 206 65.17 127.44 103.91 203.35 104.42 206 112.61 205.94 113.09 203.34 151.83 127.44 193.34 206 210.31 206 151.7 95.63 151.69 95.63"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIsoFooter);
export default __webpack_public_path__ + "static/media/logo-iso-footer.16abf77456e1bde4f77743cdbf8e0bec.svg";
export { ForwardRef as ReactComponent };